import {
  leadAttributeOptionsSelector,
  leadSourceOptionsSelector, leadStagesSelector, userMapSelector,
} from '@repo/config-services';
import { ALL_OPERATORS_CONFIG } from 'advanced-filters/data/comparatorConfig';
import { type FilterForm } from 'advanced-filters/store/filter';
import { getValueString } from 'advanced-filters/utils/filterContentBuilderUtils';
import { useSelector } from 'react-redux';

export default function FilterListItemTextContent({
  filter,
  index,
  canEdit = false,
}: {
  filter: FilterForm;
  index?: number;
  canEdit?: boolean;
}) {
  const userMap = useSelector(userMapSelector);
  const leadStagesOptions = useSelector(leadStagesSelector);
  const leadSourceOptions = useSelector(leadSourceOptionsSelector);
  const leadAttributeOptions = useSelector(leadAttributeOptionsSelector);

  const {
    conditionKey,
    conditionComparator,
    conditionValue,
    subConditionKey,
    subConditionComparator,
    subConditionValue,
  } = filter;

  const parts: string[] = [];

  if (index !== undefined && canEdit) {
    parts.push(`${index + 1}. `);
  }

  if (conditionKey) {
    parts.push(`${conditionKey.label} of the Lead`);
  }

  if (conditionComparator) {
    parts.push(ALL_OPERATORS_CONFIG[conditionComparator].label);
  }

  if (conditionValue) {
    parts.push(getValueString(
      conditionKey.dataType,
      conditionValue,
      conditionComparator,
      userMap,
      leadStagesOptions,
      leadSourceOptions,
      leadAttributeOptions,
    ));
  }

  if (subConditionKey) {
    parts.push(`, ${subConditionKey.label || subConditionKey.value || ''}`);
  }

  if (subConditionComparator) {
    parts.push(ALL_OPERATORS_CONFIG[subConditionComparator].label);
  }

  if (subConditionValue && subConditionComparator) {
    parts.push(getValueString(
      subConditionKey.dataType,
      subConditionValue,
      subConditionComparator,
      userMap,
      leadStagesOptions,
      leadSourceOptions,
      leadAttributeOptions,
    ));
  }

  return parts.join(' ');
}
